export const USER_STATUSES = {
    'unconfirmed': '0',
    'active': '1',
    'deleted': '2',
    'merged': '3',
    'banned': '4',
    'locked': '5',
    'nonpayment': '6',
};
